import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const profileTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#002147', // Antes azul marino, ahora blanco
      },
      secondary: {
        main: '#FFD700', // Dorado base
      },
      error: {
        main: '#B22222', // Rojo oscuro para errores
      },
      warning: {
        main: '#FFD700', // Dorado base
      },
      info: {
        main: '#FFD700', // Dorado base
      },
      success: {
        main: '#228B22', // Verde para éxito
      },
      background: {
        default: '#fffffF', // Fondo blanco
        paper: '#ffffff', // Fondo blanco
      },
      banner: {
        info: '#FFD700',
        error: '#B22222',
        text: '#002147',
        link: '#FFD700',
      },
      errorBackground: '#B22222',
      warningBackground: '#FFD700',
      infoBackground: '#FFD700',
      text: {
        primary: '#000000', // Texto principal negro
        secondary: '#000000', // Texto secundario negro
        disabled: '#888888', // Texto deshabilitado gris
      },
      navigation: {
        background: '#fdfdfd',
        indicator: '#FFD700',
        color: '#000000',
        selectedColor: '#FFD700',
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  /* below drives the header colors */
  pageTheme: {
    home: genPageTheme({ colors: ['#FFD700', '#FFD700'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#FFD700', '#FFD700'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#FFD700', '#FFD700'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#FFD700', '#FFD700'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#FFD700', '#FFD700'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#FFD700', '#FFD700'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#FFD700', '#FFD700'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#FFD700', '#FFD700'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#FFD700', '#FFD700'], shape: shapes.wave }),
  },
});